export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";